import {
  selectCustomerPhone,
  selectCustomerEmail,
} from '../../../../../store/selectors/customerProfile'
import { useSelector } from 'react-redux'
import GlobalHelpers from '../../../../../charts/lib/Helpers'
import { AgentContactButton } from './AgentContactButton'
import ScheduleTourButton from '../../ScheduleTour/ScheduleTourButton'

import styles from './AgentCardContactInfo.module.scss'

export const AgentCardContactInfo = () => {
  const customerPhone = useSelector(selectCustomerPhone)
  const email = useSelector(selectCustomerEmail)
  const phone = GlobalHelpers.formatPhone(customerPhone, true)

  return (
    <div className={styles.contactContainer}>
      {customerPhone && <AgentContactButton isPhone contact={phone} />}
      <AgentContactButton isPhone={false} contact={email} />
      <ScheduleTourButton primaryCustom className={styles.tourBtn} />
    </div>
  )
}
